<button
  [class]="
    merge(
      'cb flex',
      outline ? 'cb--ghost' : 'cb--primary',
      'cb--' + resolvedSize,
      isDanger && 'cb--danger',
      loading && 'is-loading',
      className
    )
  "
  [disabled]="disabled"
  [type]="type"
  [attr.aria-busy]="loading ? 'true' : null"
  [attr.aria-disabled]="loading ? 'true' : null"
  (click)="blockWhileLoading($event)"
>
  @if (leftIcon) {
    <span [class]="merge('cb__icon cb__icon--left', iconClass)" aria-hidden="true">
      <span class="bk-sym">{{ leftIcon }}</span>
    </span>
  }

  <span [class]="merge('cb__label', textClass)">{{ title }}</span>

  @if (loading) {
    <span class="cb__spin" aria-hidden="true"></span>
  } @else if (rightIcon) {
    <span [class]="merge('cb__icon cb__icon--right', iconClass)" aria-hidden="true">
      <span class="bk-sym">{{ rightIcon }}</span>
    </span>
  }
</button>
